import { Alert, Button, Checkbox, Form, Input, Modal, Select, Space, Typography, message } from "antd";
import InputMask from "../../../../components/inputMask";
import { useEffect, useState } from "react";
import { validateCPF } from "../../../../helpers/validators";
import { getTiposVinculos } from "../../../../api/tiposVinculos";
const { Text } = Typography;

const validator = {
  cpf_responsavel: [
    { required: true, message: "Informe o CPF!" },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || validateCPF(getFieldValue("cpf_responsavel"))) {
          return Promise.resolve();
        }
        return Promise.reject("Informe um CPF válido!");
      },
    }),
  ],
  nome_responsavel: [{ required: true, message: "Informe o nome completo!" }],
  id_cad_tipos_vinculos: [{ required: true, message: "Selecione o vínculo!" }],
  termo_responsabilidade_responsavel: [
    {
      validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error("Aceite o termo!"))),
    },
  ],
  termo_responsabilidade: [
    {
      validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error("Aceite o termo!"))),
    },
  ],
  termo_veracidade_responsavel: [
    {
      validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error("Aceite o termo!"))),
    },
  ],
};

const CadastroResponsavel = ({ onFinish, onPrevious, loadingComponent }) => {
  const [loading, setLoading] = useState(false);
  const [tiposVinculos, setTiposVinculos] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    listarTiposVinculos();
  }, []);

  const listarTiposVinculos = async () => {
    setLoading(true);
    try {
      const retorno = await getTiposVinculos();
      if (retorno?.statusCode === 200) {
        const data = retorno?.response?.data;
        let array_tipos = [];
        for (let index = 0; index < data?.length; index++) {
          array_tipos.push({ value: data?.[index]?.id, label: data?.[index]?.descricao });
        }
        setTiposVinculos(array_tipos);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (values) => {
    onFinish(values);
  };

  return (
    <Space direction="vertical" size={20}>
      <Modal
        title="Política de Privacidade"
        cancelText="Fechar"
        width={1000}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setShowModal(false)}
        open={showModal}>
        <iframe
          width={"100%"}
          height={700}
          src="https://statics.coperdia.com.br/curriculos/docs/termo_responsavel.html"
        />
      </Modal>

      <Alert
        message="Atenção"
        description="Identificamos que você possuí menos de 18 anos, portanto será necessário o preenchimento dos dados de seu responsável legal"
        type="info"
        showIcon
      />

      <Form layout="vertical" autoComplete="off" onFinish={onSubmit}>
        <Form.Item name="cpf_responsavel" label="CPF" hasFeedback rules={validator?.cpf_responsavel}>
          <InputMask
            mask="999.999.999-99"
            size="large"
            placeholder="Informe o CPF"
            disabled={loading || loadingComponent}
          />
        </Form.Item>

        <Form.Item name="nome_responsavel" label="Nome" hasFeedback rules={validator?.nome_responsavel}>
          <Input size="large" placeholder="Informe o nome completo" disabled={loading || loadingComponent} />
        </Form.Item>

        <Form.Item name="id_cad_tipos_vinculos" label="Vínculo" hasFeedback rules={validator?.id_cad_tipos_vinculos}>
          <Select
            size="large"
            placeholder="Selecione o vínculo"
            options={tiposVinculos}
            disabled={loading || loadingComponent}
          />
        </Form.Item>

        <Form.Item
          name="termo_responsabilidade_responsavel"
          valuePropName="checked"
          rules={validator?.termo_responsabilidade_responsavel}>
          <Checkbox disabled={loading || loadingComponent}>
            Declaro que sou maior de idade, o responsável legal do cidadão portador deste cadastro, e autorizo o
            cadastramento do currículo na plataforma de currículos da Copérdia. Estou ciente de que a falsidade nas
            informações acima implicará nas penalidades cabíveis previstas na plataforma de currículos da Copérdia.
          </Checkbox>
        </Form.Item>

        <Form.Item name="termo_responsabilidade" valuePropName="checked" rules={validator?.termo_responsabilidade}>
          <Checkbox disabled={loading || loadingComponent}>
            <Text>Concordo com o termo de responsabilidade. </Text>
            <Button type="link" style={{ padding: 0 }} onClick={() => setShowModal(true)}>
              Ver termo
            </Button>
          </Checkbox>
        </Form.Item>

        <Space>
          <Button size="large" type="primary" loading={loading || loadingComponent} htmlType="submit">
            Próximo
          </Button>

          <Button size="large" loading={loading || loadingComponent} onClick={onPrevious}>
            Anterior
          </Button>
        </Space>
      </Form>
    </Space>
  );
};

export { CadastroResponsavel };
